module.exports = __webpack_public_path__ + "assets/img/help_prev.8ce64e60.svg";